var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#1890FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_1740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94295 10.9713C11.2211 10.9713 12.2572 9.9352 12.2572 8.65706C12.2572 7.37891 11.2211 6.34277 9.94295 6.34277C8.6648 6.34277 7.62866 7.37891 7.62866 8.65706C7.62866 9.9352 8.6648 10.9713 9.94295 10.9713Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5716 18.6855H5.31445V17.6569C5.31445 16.4293 5.8021 15.252 6.67013 14.384C7.53816 13.516 8.71545 13.0283 9.94302 13.0283C11.1706 13.0283 12.3479 13.516 13.2159 14.384C14.0839 15.252 14.5716 16.4293 14.5716 17.6569V18.6855Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0574 6.34277C14.6712 6.34277 15.2598 6.5866 15.6938 7.02061C16.1278 7.45462 16.3717 8.04327 16.3717 8.65706C16.3717 9.27085 16.1278 9.85949 15.6938 10.2935C15.2598 10.7275 14.6712 10.9713 14.0574 10.9713",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7031 13.2236C16.5793 13.5569 17.3336 14.1484 17.8663 14.9198C18.3989 15.6912 18.6847 16.6062 18.686 17.5436V18.6853H17.1431",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_1740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon);
export default __webpack_public_path__ + "static/media/sm_icon.d5b6d3f50f639ba9142b5999c77f8583.svg";
export { ForwardRef as ReactComponent };